import React from 'react'

export function getEnvelopeSvg(style, className) {
  return (
    <svg className={className} style={style} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 21" shapeRendering="crispEdges">
      <path d="M1 0h26M0 1h28M0 2h4M24 2h4M0 3h2M3 3h2M23 3h2M26 3h2M0 4h2M4 4h2M22 4h2M26 4h2M0 5h2M5 5h2M21 5h2M26 5h2M0 6h2M6 6h2M20 6h2M26 6h2M0 7h2M7 7h2M19 7h2M26 7h2M0 8h2M8 8h2M18 8h2M26 8h2M0 9h2M9 9h2M17 9h2M26 9h2M0 10h2M9 10h3M16 10h3M26 10h2M0 11h2M8 11h2M11 11h2M15 11h2M18 11h2M26 11h2M0 12h2M7 12h2M12 12h4M19 12h2M26 12h2M0 13h2M6 13h2M20 13h2M26 13h2M0 14h2M5 14h2M21 14h2M26 14h2M0 15h2M4 15h2M22 15h2M26 15h2M0 16h2M3 16h2M23 16h2M26 16h2M0 17h4M24 17h4M0 18h3M25 18h3M0 19h28M1 20h26" />
    </svg>
  )
}


// WEBPACK FOOTER //
// ./src/battle-optin/get-envelope-svg.js